/**
 * §7.21 After-Action Review.
 *
 * Per CD R11 kill-list: After-Action and AAR Library (§7.28) were two
 * governance surfaces for past-outbreak review — same noun, different
 * scopes. Merged here: After-Action IS the library, with the current
 * AAR (PaCC's own logged decisions) pinned to top. Once a real incident
 * + Decision Log entry exists, the "current review" panel activates;
 * the historical archive below is always available for institutional-
 * memory lookups + scenario-anchor comparisons.
 *
 * Replays decisions from §7.17 Decision Log (current); reads from the
 * curated AAR_ENTRIES table in AarLibrary.tsx (historical). Since the
 * decision log is empty, the current-review panel ships as honest
 * placeholder rather than fabricated content.
 */

import { AarLibraryBody } from './AarLibrary';

export function AfterActionReview() {
  return (
    <div className="surface">
      <div className="surface__header">
        <span className="surface__sec">§7.21</span>
        <h1 className="surface__title">After-Action Review</h1>
      </div>
      <div className="surface__sub">
        Replays the engine projection behind each logged decision and scores it against the
        observed outcome (current). Searchable archive of historical outbreak responses
        below (institutional memory). EDU — NOT FOR OPERATIONAL DEPLOYMENT.
      </div>

      <div className="panel panel--accent">
        <div style={{ padding: 'var(--bm-space-4)', fontSize: 'var(--bm-text-sm)', color: 'var(--bm-text-muted)', lineHeight: 1.7 }}>
          <strong style={{ color: 'var(--bm-text)' }}>Current review — nothing to review yet.</strong>{' '}
          The §7.17 Decision Log is empty — and we will not score a fabricated incident with
          invented "observed" outcomes. Once real decisions are logged and real outcomes
          recorded, this panel replays each decision's engine projection (reproducible from
          its determinism receipt) and reports projection-vs-observed error with
          human-authored lessons.
        </div>
      </div>

      <div className="panel">
        <div className="panel__head">
          <span className="panel__title">How the current-review will work</span>
        </div>
        <table className="dtable">
          <tbody>
            <tr><td>Deterministic replay</td><td>Each review re-runs the original projection bit-identically (same engine version · seed · inputs).</td></tr>
            <tr><td>Projection vs observed</td><td>Model output at decision time is scored against the recorded real-world outcome.</td></tr>
            <tr><td>Human-authored lessons</td><td>Lessons are written by responders, not generated. PaCC supplies the data; humans write the narrative.</td></tr>
          </tbody>
        </table>
      </div>

      {/* Historical archive — searchable institutional-memory database.
          Was §7.28 AAR Library; merged here per CD R11 kill-list. */}
      <div style={{
        margin: 'var(--bm-space-5) 0 var(--bm-space-3)',
        paddingTop: 'var(--bm-space-4)',
        borderTop: '1px solid var(--bm-border)',
        fontFamily: 'var(--bm-font-mono)', fontSize: 10.5, fontWeight: 700,
        letterSpacing: '.6px', textTransform: 'uppercase',
        color: 'var(--bm-text-subtle)',
      }}>
        Historical archive · past-outbreak AARs · was §7.28
      </div>
      <AarLibraryBody />
    </div>
  );
}
